<div class="layout-col full">
  <mat-toolbar class="layout-row place-between-center gap-sm" elderTheme>
    <div class="layout-row place-start-center gap-sm">
      <button mat-icon-button matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
      <span>{{ 'manufacturing.routes.select' | translate }}</span>
    </div>
    <button mat-button (click)="showAllRoutes.set(!showAllRoutes())">
      {{
        (showAllRoutes()
          ? 'manufacturing.routes.hide-unavailable'
          : 'manufacturing.routes.show-all'
        ) | translate
      }}
    </button>
  </mat-toolbar>

  <div class="flex layout-row gap-sm">
    <app-work-item-utilisation-table
      class="flex"
      [enableSelection]="true"
      [workCenterId]="workCenterId()"
      [workOrderId]="workOrderId()"
      [itemConstraints]="itemConstraints()"
      [itemsToReload]="modifiedItemsId()"
      [initialFilter]="itemFilter"
      (selectionChanged)="selectedItems.set($event)"
    >
    </app-work-item-utilisation-table>

    <app-schedule-select-route-table
      class="flex"
      [items]="selectedItems()"
      [showAllRoutes]="showAllRoutes()"
      (itemsModifiedIds)="modifiedItemsId.set($event)"
    >
    </app-schedule-select-route-table>
  </div>
</div>
